import React from "react";

let str = `服务协议
本协议于2021年3月31日发布生效
本协议是用户与网站系统运营主体(简称“本网站系统”)之间就您通过本网站系统软件(以下称“”)使用本网站系统产品及服务等相关事宜所订立的契约。
您在申请注册流程中点击同意本协议之前,应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容特别是免除或者限制责仼的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识您应重点阅读。如您对协议有任何疑问,可向客服咨询。

当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后,即表示您已充分阅读、理解并接受本协议的全部内容,并与本网站系统达成一致,成为 “用户"。阅读本协议的过程中,如果您不同意本协议或其中任何条款约定,您应立即停止注册程序。请您注意,我们会不时地检查并更新服务协议,因此有关服务协议的內容会随之变化。我们会按照相关法律法规要求对服务协议的变更予以公示,请您定期查看协议页面及公示页面,以确保您了解用户协议的最新版本。

请您仔细阅读本注册协议,您点击“同意”按钮后,本协议即构成对双方有约束力的法律文件。

第1条 本网站系统的用户
1.1、本网站系统的用户:用户为具备中华人民共和国法律规定的与您的行为相适应的民事行为能力的人。用户应为以终端消费为目的的消费者,包括个人、国家机关、企业、事业单位及其他社会团体消费者,不包括以营利、销售等为目的的经销商。如发现用户为经销商的，本网站系统有权拒绝为其提供服务,并有权注销其注册的账户,由此产生的一切后果由其自行承担。  
1.2、本网站系统的各项电子服务的所有权和运作权归本网站系统所有。用户同意所有注册协议条款并完成注册程序,才能成为本网站系统的正式用户。用户确认:本协议条款是处理双方权利义务的契约,始终有效,法律另有强制性规定或双方另有特别约定的,依其规定。
1.3、用户选择本网站系统支持的任一登录方式(包括手机验证码登录、本机号码一键登录、微信登录)等登录并点击同意本协议的,即视为用户具备中华人民共和国法律规定的与您行为相适应的民事行为能力,能够独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力,本网站系统有权随时、全权决定拒绝向您提供服务,您及您的监护人应依照法律规定承担因此而导致的一切后果。
1.4、本网站系统保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
1.5、由于互联网高速发展,您与本网站系统签署的本协议列明的条款并不能完整罗列并覆盖您与本网站系统所有权利与义务,现有的约定也不能保证完全符合未来发展的需求。因此,本网站系统隐私权政策等均为本协议的补充协议,与本协议不可分割且具有同等法律效力。如您使用本网站系统服务,视为您同意上述补充协议。
1.6同一用户多次重复注册本网站系统账户会对该用户身份的真实性、获取账户的合理动机等产生质疑。除非该用户对其试图重复获取账号的行为作出合理解释,否则为保护广大真实用户的真实消费需求与合法权益,本网站系统会拒绝或者直接注销您所有重复注册的账户,同时终止对这些重复注册账户提供服务。

第2条 本网站系统的服务
2.1、本网站系统通过互联网依法为用户提供互联网信息等服务,用户在完全同意本协议及本网站系统规定的情況下,方有权使用本网站系统的相关服务商品交易相关服务。
2.2、在您下订单时,请您仔细确认所购商品的名称、价格、数量、规格、包装、保质期等信息以及联系地址电话、收货人等信息。收货人与您本人不一致时,收货人的行为和意思表示视为您的行为和意思表示,您应对收货人的行为和意思表示的法律后果承担连带责任。
2.3、针对本网站系统上的水果生鲜类产品,您充分理解出于水果生鲜食品仓储、运输的特殊性考虑,部分商品可能对销售区域作出限制,请您在下单时务必仔细查看商品详情页并准确填写收货地址,当收货地址超出配送范围时,本网站系统有权拒绝接受您的订单。
2.4、您充分理解并同意:“当您作为消费者于本网站系统下单并支付货款的情况下,您货款支付成功后即视为您与本网站系统之间就已支付货款部分的订单建立了合同关系。”
2.5、对于由本网站系统销售的商品,直到您发出订单并经我们确认发货,我们才能确认该商品的售价。尽管我们尽最大努力确保商品价格的准确性,商品目录中的一小部分商品可能偶尔会有定价错误。如果某一商品的正确定价应高于我们的网站定价,我们有权根据具体情况决定,在发货前联系您咨询您的意见,或者取消您的订单并通知您。
2.6、本网站系统有权在发现上显示的商品及订单明显错误或缺货的情况下单方面撤回前述信息及订单。本网站系统保留对商品订购数量的限制权,商品价格和可获得性都将在上标明。送货费将另外结算费用，根据用户选择的送货方式的不同而产生差异。
2.7、本网站系统提供的服务内容可能包括:文字、软件音乐、图片、录像、图表等。所有这些内容受著作权、商标和其它财产所有权法律的保护。
2.8、用户只有在获得本网站系统或其他相关权利人的授权之后才能使用2.7所述的内容,不能擅自复制、再造前述内容、或创造与内容有关的派生产品。
2.9、您不应通过本网站系统发布他人受知识产权法律等保护的内容,除非获得他人合法授权。就用户发布的内容,若第三方向本网站系统投诉并提交初步证据的,经本网站系统判断投诉属实的,本网站系统将会删除这些内容,如因用户发布内容而给本网站系统带来损失的,用户应当负责赔偿。
2.10用户知悉、理解并同意其通过本网站系统发布上传的内容,授权本公司及其关联公司、控制公司可在全球范围内、免费、非独家、可转授权地使用,使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等,并授权公司及其关联公司、控制公司对相应内容可进行修改、复制、改编、翻译、汇编或制作衍生产品。

第3条 用户信息
3.1、用户应自行诚信向本网站系统提供注册资料,用户同意其提供的注册资料真实、准确、完整、合法有效,用户注册资料如有变动的,应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的,用户需承担因此引起的相应责任及后果,并且本网站系统保留终止用户使用本网站系统各项服务的权利,您了解并同意,您有义务保持您提供信息的真实性及有效。
3.2、用户在本网站系统进行浏览、下单购物等活动时,涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的,本网站系统将予以严格保密,除非
1)事先获得您的明确授权
2)系为履行您的订单或保护您的合法权利所必须
3)相应的法律程序及相关政府部门要求本网站系统提供的。
3.3、用户注册成功后,将产生用户名和密码等账户信息,您可以根据本网站系统规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况,请立即通知本网站系统并向公安机关报案本网站系统账户与您的非现金支付工具是密切挂钩的,交由他人使用可能会造成您本人的支付工具端产生债权债务纠纷、資信问题等不良影响,因此本网站系统建议您不要将自己的账户给予他人使用。从公平合理的角度出发，您应知晓所有通过账户实现的操作,本网站系统只能默认是您本人的行为,由此产生的后果由您自行独立承担。
3.4、用户同意,本网站系统拥有通过邮件、短信、电话等形式,向在本网站系统注册、购物用户、收货人发送订单信息、本网站系统活动等告知信息的权利,您如果不愿意接收此类信息,您有权通过本网站系统提供的相应的退订功能进行退订。
3.5除非有法律规定或依生效司法裁决,或者根据本网站系统公布的条件以及流程,用户不得以任何方式将在本网站系统注册获得的账户转让或借给他人使用,否则本网站系统有权追究您的违约责任,由此产生的一切责任均应当由您以及实际使用人承担连带责任。
3.6、用户同意,本网站系统有权使用用户的注册信息、用户名、密码等信息,登录进入用户的注册账户,进行证据保全,包括但不限于公证、见证等。
3.7、您设置的会员名、昵称不得违反国家法律法规规定,否则本网站系统可回收您的会员名、昵称,若由此对本网站系统造成损害的,您应承担相应赔偿责任。
3.8、除本网站系统存在过错外,您应对您账户项下的所有行为结果(包括但不限于在线签暑各类协议、发布信息、购买商品及服务及披露信息等)负责。

第4条 用户行为
本协议依据国家相关法律法规规章制定,用户同意严格遵守以下义务：
(1)不得传输或发表:煽动抗拒、破坏宪法和法律、行政法规实施的言论,煽动颠覆国家政权,推翻社会主义制度的言论,煽动分裂国家、破坏国家统的言论,煽动民族仇恨、民族歧视、破坏民族团结的言论
(2)从中国大陆向境外传输资料信息时必须符合中国有关法规
(3)不得利用本网站系统从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动
(4)不得干扰本网站系统的正常运转,不得侵入本网站系统及国家计算机信息系统
(5)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料
(6)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论
(7)不得教唆他人从事本条所禁止的行为
(8)不得利用在本网站系统注册的账户进行牟利性经营活动
(9)不得发布任何侵犯他人著作权、商标权等知产权或合法权利的内容
用户应不时关注并遵守本网站系统不时公布或修改的各类合法规则规定。本网站系统保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的,本网站系统有权作出独立判断并采取暂停或关闭用户帐号等措施。用户将以自己的名义对自己在网上的言论和行为独立承担所有法律责任。

第5条 会员活动
5.1、您可以通过在本网站系统网站参与商品评价、邀请其他用户等方式成为本网站系统的会员活动。会员活动具有特定的规则和有效期,请您不时关注相关信息,活动规则以实际活动页上发布的为准。本网站系统可根据活动举办的实际情况,在法律允许的范围内,对具体的活动规则进行变动或调整,相关变动或调整以公布在活动规则页面为准。

第6条 商品评价管理
6.1、您有权在本网站系统提供的评价系统中对与您达成交易的商品及/或服务进行评价。您应当理解,您在本网站系统的评价信息是公开的,如您不愿意在评价信息中向公众披露您的身份信息,您有权选择通过匿名形式发表评价内容。
6.2、您的所有评价行为应遵守本网站系统规则的相关规定,评价內容应当客观真实,不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息;您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。本网站系统可对您实施上述行为所产生的评价信息进行处理。

第7条 配送
7.1、销售方将会把商品(货物)送到您所指定的收货地址,所有在本网站系统上列出的送货时间为参考时间,参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估算得出的。参考时间不等同于实际到货时间,本网站系统不会就送达时间向您作出精准承诺,您理解由于受库存、同时段订单量及其他外部因素的影响,实际送货时间可能会早于或晚于参考时间。
7.2、因如下情况造成订单延迟或无法配送等,本网站系统不承担延迟配送以及订单商品无法送达的责任：
(1)用户提供的信息错误、地址不详细等原因导致
(2)货物送达后无人签收或交由他人代收前无法获得用户同意,导致无法配送或延迟配送的
(3)情势变更因素导致的
(4)不可抗力因素导致的,例如:自然灾害、交通戒严、突发战争等
(5)未能在本网站系统所示的送货参考时间內送货的
(6)因节假日、大型活动、店庆、预购或抢购人数众多等原因导致的
7.3、配送费用以您提交订单时页面显示的运费为准。您理解,如您需要变更时间或地址进行重新配送的,可能需要承担额外产生的配送服务费用。
7.4、为了保证配送及时准确、商品品质令人满意,您应当清楚准确地填写您的收货地址、联系人及联系方式等配送信息,您同意并授权本网站系统将您的配送信息粘贴在商品外包装上,您理解这是为向您提供物流配送服务而必须的动作,本网站系统提醒您收到商品后立即销毁外包装上的个人信息以保证个人信息安全。您知悉并确认,您所购买的商品应仅由您填写的联系人接受身份查验后接收商品,因您变更联系人或相关配送信息而造成的损失由您自行承担。

第8条 知识产权
8.1、用户同意接受本协议,即表明该用户主动将其在任何时间段在本网站系统发表的任何形式的信息内容(包括但不限于客户评价、客户咨询、各类话题文章等信息内容)的财产性权利等任何可转让的权利,如著作权财产权(包括但不限于:复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利),全部不可撤销地授予本网站系统使用。
8.2、本网站系统拥有此相关app上内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本网站系统的内容进行修改,并在本网站系统发布。在法律允许的最大限度范围内,本网站系统对本协议及本网站系统内容拥有解释权。
8.3、除法律另有强制性规定外,未经本网站系统明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本网站系统的信息內容,否则,本网站系统有权追究其法律责任。
8.4、本网站系统所刊登的资料信息(诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件),均是本网站系统或其内容提供者的财产,受中国和国际版权法的保护。本网站系统上所有内容的汇编是本网站系统的财产,受中国和国际版权法的保护。本网站系统上所有软件都是本网站系统或其关联公司或其软件供应商的财产,受中国和国际版权法的保护。

第9条 免责条款
9.1、除非另有明确的书面说明,本网站系统不对本网站系统的运营及其包含在本网站上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保。
9.2、您理解本网站系统将严格按照法律规定以及本协议的约定,为您提供可靠、安全的产品及服务,但发生下列情形之一导致您遭受损失的,本网站系统将不承担责任
(1)由于您未爱善管理您的账号信息,或未妥善保管您的登录设备的;
(2)发生设备维护、信息网络连接故障、智能终端、通讯或其他系统故障等情形的；
(3)发生地震、海啸、台风、洪水、战争、武斗冲突、罢工、骚乱、暴动、行政机构或司法机构发布命令等不可抗力事件的;
(4)其他非因本网站系统原因造成的。

第10条 法律管辖和适用
10.1、本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律(但不包括其冲突法规则)。如发生本协议与适用之法律相抵触时,则该条款将完全按法律规定重新解释,而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议,双方应尽力友好协商解决;协商不成时,任何一方均可向本网站系统住所地有管辖权的法院提起诉讼。

第11条 违约条款
11.1出现以下情况之一时,视为您违约
(1)使用货到付款支付方式,短期内多次(连续1个月内5次以上)在本网站系统向您发货后至您付款前取消订单的
(2)多次(2次以上)在评论区或咨询区发布与所售商品无关的广告、辱骂等信息的或多次恶意进行负面评价的
(3)本网站系统认为您通过会员账户购物从事转售业务的(从事批发、零售等)
(4)利用本网站系统过错恶意索赔、投诉,无故对客服人员进行辱骂、人身攻击的
(5)违反本协议、本协议补充协议以及本网站系统各项规则的
(6)违反有关法律法规规定的
(7)您通过网络攻击、大量发布广告等行为的
(8)您多次(2次及以上)利用本网站系统网站的漏洞,恶意下单,谋取利益的
(9)您通过外挂工具、网络攻击或其他不正当行为非法获取优惠券等虚拟财产的(对此本网站系统有权在不进行提前告知的情况下对违规账户进行冻结清算处理,并保留追究相关人员法律责任的权利）
(10)您提供的用户信息(包括但不限于姓名、电话、身份证号、电子邮箱等)不真实、不准确或不完整的
(11)您盗用他人账户、发布违禁信息、骗取他人财物、扰乱市场秩序、采取不正当手段谋利等行为的
(12)除特殊说明外并非仅针对单一账号,对于用户,如您在一段时间内通过多个账号下单,但本网站系统通过收件地址、下单地址、联系电话、银行卡移动设备识别码等判断实际购买人为ー人或与您有紧密关联
(13)您多次违反本网站系统规则相关规定且依据本网站系统判断情节严重的
(14)您有其他影响网站正常经营秩序或违法行为的
11.2、本网站系统有权根据您的违约行为实施如下违约处理措施：
(1)限制或取消会员账户的部分或者全部权限或功能(包括但不限于:货到付款、网页回复评价、在线评价、下单、参加本网站系统活动等）
(2)取消与违约行为相关的订单
(3)立即对相应信息进行删除、屏蔽处理
(4)情节严重的查封您的账户,终止向您提供服务
11.3、如您的行为使本网站系统及/或其关联公司遭受损失(包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失),您应赔偿本网站系统及/或其关联公司的上述全部损失。

第12条 协议的变更
本网站系统可根据国家法律法规变化及维护交易秩序、保护消费者权益需要,不时修改本协议、补充协议,变更后的协议、补充协议(下称“变更事项”)将通过本网站系统通知您。本网站系统将会按照相关法律法规要求对本协议的变更予以公示,请您定期查看协议页面及公示页面。
用户可随时登录査阅最新协议,并有权提出相关反馈建议;用户有义务不时关注并阋读最新版的协议及公告。
如您对已生效的变更事项仍不同意的,您应当于变更事项确定的生效之日起停止使用本网站系统服务,变更事项对您不产生效力;如您在变更事项生效后仍继续使用本网站系统服务,则视为您同意已生效的变更事项。

第13条 通知
13.1、有效联系方式
您在注册成为本网站系统用户并接受本网站系统服务时，您应该向本网站系统提供真实有效的联系方式(包括您的电子邮件地址、联系电话、联系地址等),对于联系方式发生变更的,您有义务及时更新有关信息,并保持可被联系的状态。您在使用本网站系统用户时生成的收货信息,也作为您的有效联系方式。本网站系统将向您的上述联系方式的其中之一或其中若干向您送达各类通知,而此类通知的内容可能对您的权利义务产生重大的有利或不利影响,请您务必及时关注。
13.2、通知的送达
本网站系统通过上述联系方式向您发出通知,其中以电子的方式发出的书面通知,包括但不限于在本网站系统公告,向您提供的联系电话发送手机短信,向您提供的电子邮件地址发送电子邮件,向您的账号发送系统消息以及站内信信息,在发送成功后即视为送达;以纸质载体发出的书面通知,按照提供联系地址交邮后的第五个自然日即视为送达。
对于与本网站系统有关的任何纠纷,您同意行政、公安、司法等有权机关可以通过手机短信、电子邮件、系统消息或站内信等方式向您送达法律文书,有权机关向上述联系方式发出法律文书即视为送达;若同时采取以上多种方式向您送达法律文书,送达时间以最先送达的为准。您同意上述送达方式适用于行政、仲裁、司法等法定程序全过程。

第14条 服务终止的情形
14.1、您有权通过以下任一方式终止本协议并不再接受本网站系统的服务
(一)您通过本网站系统注销您的账户
(二)变更事项生效前您停止使用并明示不愿接受变更事项的
(三)其它应当终止协议的情况
14.2、出现以下情况时,本网站系统可通过本协议所列的方式通知您终止本协议并终止服务
(一)您违反本协议约定,本网站系统依据违约条款终止本协议的
(二)您盗用他人账户、发布违禁信息、骗取他人财物、扰乱交易秩序、采取不正当手段谋利等为,本网站系统对您的账户予以查封的
(三)除上述情形外,因您多次违反本网站系统服务协议及规则等协议内容相关规定且情节严重,本网站系统对您的账户予以查封的
(四)您的账户被本网站系统依据本协议回收的
(五)其它应当终止服务的情况

第15条 其他
15.1、如果根据适用的法律认定本协议中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性,这种无效、违法或者不具有可执行性不影响本协议中的任何其它条款或者这些条款中的任何其它部分的效力。
15.2、本网站系统尊重用户和消费者的合法权利,本协议及本网站系统上发布的各类规则、声明等其他内容,均是为了更好地、更加便利地为用户和消费者提供服务。本网站系统欢迎用户和社会各界提出意见和建议,本网站系统将酌情考虑接受并适时修改本协议及本网站系统上的各类规则。
15.3、您在点击“登录”《本网站系统服务协议》时即视为您完全接受本协议,在登录之前请您再次确认已知悉并完全理解本协议的全部内容。
`;

export default function ({ inModal }) {
    let arr = str.split("\n");
    return (
        <div className="privacy" style={{ padding: inModal ? 0 : "30px 180px 0" }}>
            {arr.map((item, index) => {
                if (index === 0) {
                    return <h1 style={{ textAlign: "center", marginBottom: 30 }}>{item}</h1>;
                } else if (index === 1) {
                    return <p className="privacy-time">{item}</p>;
                } else {
                    return <p className="privacy-desc">{item}</p>;
                }
            })}
        </div>
    );
}
